module.exports = __webpack_public_path__ + "static/media/just-do-it.73bda03a.wav";